import { Utility, utility_controller } from '../utility/utility_controller'
import { load_visible_images_then_rest_controller } from '../utility/load_visible_images_then_rest'
import load_html5_videos_controller from '../html5video/load_html5_videos_controller'
import load_lazy_iframes_controller from '../lazy_iframes/load_lazy_iframes_controller'
import { attachHlsIfNeeded } from '../html5video/hls_loader'
import { prefetchLayPretextLazyModulesEarly } from '../textanimations/pretext_lazy'
import { injectAllDataEmbedsIn, init as initEmbedInject } from './embed_inject'

// todo: re-code this so it works with any combinations of overlays with a wout cpl, and normal page w o wo cpl

/* when i view a page's cpl on small browser width, the images, videos etc of the desktop version should not be loaded
 when i view a page's desktop version but there is a cpl, the images, videos etc of the cpl version should not be loaded

step 1: 
is a cpl available for this page? √

step 2:
the following assets in elements need to NOT be loaded on init:
- image √
- thumbnail √
- row background image √
- thumbnail mouseover image √
- html5-video-placeholder-image √
- html5 video √
- html5 video thumbnail √
- html5 row background video √
- youtube video √
- vimeo video √
- thumbnailgrid √
- elementgrid √
- image of video row background √
- embed √
- elements in carousel √

test this for when images are lazyloaded and for when images are not lazyloaded √
test this with "show original images" activated √
test with gif √

test when cpl ability is disabled in lay options 

step 3: in JS on document ready, trigger a "loadContent" function. it sets the element's attributes so they can load. 
depending on whether desktop or cpl is showed of course √

step 4:
when switching from desktop to cpl, then load cpl assets √
when swichting from cpl to desktop, then load desktop assets √

needs to work for footer and main region. footer might have cpl but main region might not √
*/

var $target

var load_cpl_or_desktop_content_controller = {
	i: function () {
		i()
	},
}

var mainRegion = {
	desktopContentLoaded: false,
	CplContentLoaded: false,
}

var footer = {
	desktopContentLoaded: false,
	CplContentLoaded: false,
}

isProjectOverlayObjGlobal = false

var i = function () {
	resetContentLoadedStatus()
	window.laytheme.on('newpageshown', resetContentLoadedStatus)
	window.laytheme.on('newpageshown', function (layoutObj, type, obj, isProjectOverlayObj) {
		isProjectOverlayObjGlobal = isProjectOverlayObj
		// use set timeout to make sure "resetContentLoadedStatus" is called before this
		setTimeout(function () {
			loadDesktopOrCPLContent(isProjectOverlayObj)
		}, 0)
	})
	// when switching between desktop and phone version, maybe load content if it hasn't already!
	window.laytheme.on('sizechanged', function () {
		loadDesktopOrCPLContent(isProjectOverlayObjGlobal)
	})
	initEmbedInject()
}

var loadDesktopOrCPLContent = function (isProjectOverlayObj) {
	prefetchLayPretextLazyModulesEarly()
	switch (Utility.screenSize) {
		case 'desktop':
		case 'tablet':
			loadDesktopContentHelper()
			break
		case 'phone':
			// either load desktop content that is on phone size (automatically created phone layout)
			// or load cpl content
			loadPhoneContentHelper(isProjectOverlayObj)
			break
	}
	loadWooCommerceImages()
	pauseInvisibleVideos()

	setTimeout(function () {
		var typeOfContentThatIsReady = Utility.screenSize == 'desktop' || Utility.screenSize == 'tablet' ? 'desktop' : 'phone'
		window.laytheme.emit('content_ready', typeOfContentThatIsReady, $target, isProjectOverlayObj)
	}, 0)
}

// need this in case lazyloading was turned off in lay options
var loadWooCommerceImages = function () {
	var $target = jQuery('#lay-woocommerce')
	switch (layData.image_loading) {
		case 'instant_load':
			load_visible_images_then_rest_controller.initLoadImages($target)
			utility_controller.fadeInImageOnLoadViaParent($target)
			break
		case 'lazy_load':
			// when image loading is set to lazyload, I don't need to do anything here
			break
	}
}

var pauseInvisibleVideos = function () {
	// as a workaround of not being able to lazyload html5videos on firefox, I make sure I pause html5 videos
	document.querySelectorAll('video').forEach(function (video) {
		if (!jQuery(video).is(':visible')) {
			video.pause()
		}
	})
}

// Carousel slides use data-lay-* + carousel-* classes, not .lazyload — vanilla-lazyload never loads them.
// critical_init does this once on newpageshownfast; repeat for the DOM regions we activate here (SPA / CPL).
var CAROUSEL_EAGER_VIEWPORT_OFFSET_PX = 100

var isCarouselViewportForEagerLoad = function (el) {
	if (!el || typeof el.getBoundingClientRect !== 'function') {
		return false
	}
	var rect = el.getBoundingClientRect()
	return (
		rect.bottom > 0 &&
		rect.top < window.innerHeight + CAROUSEL_EAGER_VIEWPORT_OFFSET_PX &&
		rect.right > 0 &&
		rect.left < window.innerWidth
	)
}

var setCarouselImgSizesAttribute = function (img) {
	if (!img || typeof img.getBoundingClientRect !== 'function') {
		return
	}
	var w = img.getBoundingClientRect().width
	var objectfit = window.getComputedStyle ? window.getComputedStyle(img).objectFit : ''

	if (w === 0) {
		var ar = parseFloat(img.getAttribute('data-ar'))
		var h = img.clientHeight
		if (!Number.isNaN(ar) && ar !== 0 && h > 0) {
			w = h / ar
		}
	}

	var parentFit = img.getAttribute('data-parent-fit')
	if (parentFit === 'cover' || objectfit === 'cover') {
		var dataW = parseInt(img.getAttribute('data-w'), 10)
		var dataH = parseInt(img.getAttribute('data-h'), 10)
		if (!Number.isNaN(dataW) && !Number.isNaN(dataH) && dataH !== 0) {
			var rect = img.parentNode ? img.parentNode.getBoundingClientRect() : null
			if (rect && rect.width === 0 && rect.height === 0 && img.parentNode && img.parentNode.parentNode) {
				rect = img.parentNode.parentNode.getBoundingClientRect()
			}
			if (rect && rect.height > 0) {
				if (dataW / dataH < rect.width / rect.height) {
					w = rect.width
				} else {
					var imgH = rect.height
					w = (dataW / dataH) * imgH
				}
			}
		}
	}

	if (w && w > 0) {
		var rounded = utility_controller.roundUpSizes(w)
		img.setAttribute('sizes', rounded + 'px')
		img.setAttribute('data-sizes', rounded + 'px')
	}
}

var loadCarouselSlideImageFromLayData = function (img) {
	if (!img) {
		return
	}
	if (img.classList.contains('carousel-original-img')) {
		var originalSrc = img.getAttribute('data-lay-src')
		if (originalSrc) {
			img.setAttribute('src', originalSrc)
		}
	} else if (img.classList.contains('carousel-responsive-img')) {
		var srcset = img.getAttribute('data-lay-srcset')
		var src = img.getAttribute('data-lay-src')
		setCarouselImgSizesAttribute(img)
		if (srcset) {
			img.setAttribute('srcset', srcset)
		}
		if (!srcset && src) {
			img.setAttribute('src', src)
		}
	}
	if (img.complete) {
		img.classList.add('loaded')
	} else {
		img.addEventListener(
			'load',
			function () {
				img.classList.add('loaded')
			},
			{ once: true }
		)
		img.addEventListener(
			'error',
			function () {
				img.classList.add('loaded')
			},
			{ once: true }
		)
	}
}

var loadCarouselLazyVideoSimple = function (video) {
	var i
	for (i = 0; i < video.children.length; i++) {
		var child = video.children[i]
		if (child && child.tagName === 'SOURCE' && child.dataset && child.dataset.src != undefined) {
			child.src = child.dataset.src
		}
	}
	video.setAttribute('preload', 'auto')
	try {
		video.load()
	} catch (e) {}
	video.classList.remove('video-lazyload')
	video.classList.add('loaded')
	if (video.classList.contains('autoplay')) {
		video.setAttribute('autoplay', '')
	}
	attachHlsIfNeeded(video)
}

var eagerLoadAboveTheFoldCarouselsInRoots = function ($target) {
	if (!$target || !$target.length) {
		return
	}
	var c, carousel, slideImages, i, maxSlides, lazyVideos, j
	$target.each(function () {
		var root = this
		if (!root || !root.querySelectorAll) {
			return
		}
		var carousels = root.querySelectorAll('.lay-carousel')
		for (c = 0; c < carousels.length; c++) {
			carousel = carousels[c]
			if (!isCarouselViewportForEagerLoad(carousel)) {
				continue
			}
			slideImages = carousel.querySelectorAll(
				'.lay-carousel-slide img.carousel-original-img, .lay-carousel-slide img.carousel-responsive-img'
			)
			maxSlides = Math.min(slideImages.length, 2)
			for (i = 0; i < maxSlides; i++) {
				loadCarouselSlideImageFromLayData(slideImages[i])
			}
			lazyVideos = carousel.querySelectorAll('.lay-carousel-slide video.video-lazyload')
			for (j = 0; j < lazyVideos.length; j++) {
				if (isCarouselViewportForEagerLoad(lazyVideos[j])) {
					loadCarouselLazyVideoSimple(lazyVideos[j])
				}
			}
		}
	})
}

var loadDesktopContentHelper = function () {
	// load main region desktop
	if (!mainRegion.desktopContentLoaded) {
		var nodes = []
		// need to iterate .lay-content here to target overlays too
		document.querySelectorAll('.lay-content').forEach(function (laycontent) {
			nodes = nodes.concat(Array.from(laycontent.querySelectorAll('#grid, .cover-region-desktop')))
		})
		$target = jQuery(nodes)
		// $target = jQuery('#grid, .cover-region-desktop')
		loadContent($target)
		mainRegion.desktopContentLoaded = true
	}
	// load footer region desktop
	if (!footer.desktopContentLoaded) {
		$target = jQuery('#footer')
		if ($target.length > 0) {
			loadContent($target)
		}
		footer.desktopContentLoaded = true
	}
}

// phone content can either be cpl or desktop content that is the automatically generated phone layout.
// The automatically generated phone layout is not new markup but the same, it just looks different because of CSS
var loadPhoneContentHelper = function (isProjectOverlayObj) {
	var parent = isProjectOverlayObj != undefined && isProjectOverlayObj.isProjectOverlay ? '#lay-project-overlay>.lay-content' : 'body>.lay-content'
	// CPL or Automatically Generated Phone Layout?
	if (document.querySelector(parent + ' #custom-phone-grid')) {
		mainRegion.hasCPL = true
	} else {
		mainRegion.hasCPL = false
	}
	if (document.querySelector(parent + ' #footer-custom-phone-grid')) {
		footer.hasCPL = true
	} else {
		footer.hasCPL = false
	}

	// load main region cpl, or load "desktop" content that is automatically generated phone layout
	if (mainRegion.hasCPL) {
		if (!mainRegion.CplContentLoaded) {
			// $target = jQuery('#custom-phone-grid, .cover-region-phone')
			var nodes = []
			// need to iterate .lay-content here to target overlays too
			document.querySelectorAll('.lay-content').forEach(function (laycontent) {
				nodes = nodes.concat(Array.from(laycontent.querySelectorAll('#custom-phone-grid, .cover-region-phone')))
				if (laycontent.parentNode.classList.contains('lay-overlay')) {
					// if this div is inside a page overlay, it might not have a cpl, so we also need to load the normal #grid
					nodes = nodes.concat(Array.from(laycontent.querySelectorAll('#grid')))
				}
			})
			$target = jQuery(nodes)
			loadContent($target)
			mainRegion.CplContentLoaded = true
		}
	} else {
		if (!mainRegion.desktopContentLoaded) {
			var nodes = []
			// need to iterate .lay-content here to target overlays too
			document.querySelectorAll('.lay-content').forEach(function (laycontent) {
				nodes = nodes.concat(Array.from(laycontent.querySelectorAll('#grid, .cover-region-desktop')))
				if (laycontent.parentNode.classList.contains('lay-overlay')) {
					// using selectors #custom-phone-grid
					// here too, because an overlay could contain a cpl
					nodes = nodes.concat(Array.from(laycontent.querySelectorAll('#custom-phone-grid')))
				}
			})
			$target = jQuery(nodes)
			loadContent($target)
			mainRegion.desktopContentLoaded = true
		}
	}

	// load footer cpl, or load "desktop" footer content that is automatically generated phone layout
	if (footer.hasCPL) {
		if (!footer.CplContentLoaded) {
			$target = jQuery('#footer-custom-phone-grid')
			loadContent($target)
			footer.CplContentLoaded = true
		}
	} else {
		if (!footer.desktopContentLoaded) {
			$target = jQuery('#footer')
			if ($target.length > 0) {
				loadContent($target)
			}
			footer.desktopContentLoaded = true
		}
	}
}

var loadContent = function ($target) {
	// IMAGE LOADING:

	// tested with:
	// images instant_load, responsive images √
	// images lazy_load, responsive images √
	// gif lazy load √
	// gif instant load √
	// row background gif lazyload and instant load √
	// row background image lazyload and instant load √
	// images instant_load, "never show resized versions of images" √
	// images lazy_load, "never show resized versions of images" √
	// thumbnail mouseover image gif/normal/nevershowresized/instantload/lazyload √
	// html5-video-placeholder-image √
	// thumbnail √
	// intro image ?? - ist egal
	// row video background image placeholder √
	switch (layData.image_loading) {
		case 'instant_load':
			load_visible_images_then_rest_controller.initLoadImages($target)
			utility_controller.fadeInImageOnLoadViaParent($target)
			break
		case 'lazy_load':
			// when image loading is set to lazyload, I don't need to do anything here
			break
	}

	// HTML 5 VIDEO LOADING:
	// html5 video element √
	// video in thumbnail √
	// video row background √
	// does this handle html5 videos in carousels too? i think so, but i need to double check this

	if (load_html5_videos_controller.shouldLazyLoadVideos()) {
		load_html5_videos_controller.initLazyLoadVideosOnScroll($target)
	} else {
		// The layout cache is browser-neutral. Apply the Safari / Firefox /
		// Instagram exception from this request before hydrating cached videos.
		load_html5_videos_controller.loadVideosInstantly($target)
	}

	// YOUTUBE / VIMEO VIDEO LOADING:
	// iframes NOT marked for lazyload: restore src immediately (existing behavior,
	// used when project overlays are off and per-provider lazyload is off).
	$target.find('iframe[data-src]:not(.lay-iframe-lazyload)').each(function () {
		var data_src = jQuery(this).attr('data-src')
		jQuery(this).attr('src', data_src)
	})

	// thumbnailgrid, images and videos are loaded above (html5 videos, images) √
	// elementgrid, images and videos are loaded above (html5 videos, images) √

	// EMBED / HTML / SHORTCODE
	// Hydrate via the shared injector so embedded snippets that rely on
	// DOMContentLoaded / window.load still work after late injection.
	injectAllDataEmbedsIn($target)

	// iframes marked for lazyload (per-provider Vimeo/YouTube option on): load when
	// they scroll near the viewport instead of all up front. Runs AFTER
	// injectAllDataEmbedsIn so raw HTML-element embeds AND Smart-Loading embeds
	// (pasted Vimeo/YouTube iframes, the common case) are both covered.
	load_lazy_iframes_controller.initLazyLoadIframesOnScroll($target)

	// note to myself: layCarouselFadeCarousel.loadFirstLazyImage($target) only loads first image if its in viewport
	// thats why for overlays i need to call this once overlay has shown

	// CAROUSEL
	// data-lay-src / carousel-responsive-img are not .lazyload — eager-load first slides when carousel is in viewport
	// (lazy_load and instant_load; vanilla-lazyload never touches these)
	if (typeof window.layCarousel != 'undefined' && typeof window.layCarousel.loadNotLazyloadingImagesIn != 'undefined') {
		// this is just for when the carousel images should not get lazyloaded
		// SWIPER / FADE CAROUSEL:
		window.layCarousel.loadNotLazyloadingImagesIn($target)
	}

	// SWIPER CAROUSEL
	// if the carousel images are lazyload and swiper, the carousels' lazyLoadVisibleImages function will handle this,
	// it is called in swiperCarousel's onSelect function

	// FADE CAROUSEL:
	// if the carousel images are lazyload and fade, the fadeCarousel's following function will handle this:
	if (typeof window.layCarouselFadeCarousel != 'undefined' && typeof window.layCarouselFadeCarousel.loadFirstLazyImage != 'undefined') {
		window.layCarouselFadeCarousel.loadFirstLazyImage($target)
	}
	// SCROLL CAROUSEL:
	if (typeof window.layCarouselScrollCarousel != 'undefined' && typeof window.layCarouselScrollCarousel.loadFirstLazyImage != 'undefined') {
		window.layCarouselScrollCarousel.loadFirstLazyImage($target)
	}

	eagerLoadAboveTheFoldCarouselsInRoots($target)
}

var resetContentLoadedStatus = function () {
	mainRegion.desktopContentLoaded = false
	mainRegion.CplContentLoaded = false
	footer.desktopContentLoaded = false
	footer.CplContentLoaded = false
}

export default load_cpl_or_desktop_content_controller
